import React, { useCallback, useEffect, useMemo, useContext, useRef, useState } from 'react';
import type { NextPage } from 'next';
import styles from './index.module.scss';
import classNames from 'classnames';
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import CountUp from 'react-countup';
import { Progress } from '@douyinfe/semi-ui';
import Head from 'next/head';
import useRequest from '@/utils/useRequest';
import { getHead, getServerSideProps } from '@/utils/useHead';
import { useDate } from '@/utils/useDate';
import { useRouter } from 'next/router';

interface IProps {

}
export { getServerSideProps }


const Home: NextPage<IProps> = ({ navDetail }: any) => {
  const [activeIndex, setActiveIndex] = useState(1)
  const [isLoad, setIsLoad] = useState(false)
  const [data, setData] = useState<any>({})
  const request = useRequest()
  const router = useRouter()

  const chunkArray = useCallback((arr: any, chunkSize: number) => {
    const chunkedArray = [];
    let index = 0;
    while (index < arr.length) {
      const end = Math.min(index + chunkSize, arr.length);
      chunkedArray.push(arr.slice(index, end));
      index = end;
    }
    return chunkedArray;
  }, [])

  const handleSlideChange = useCallback((swiper: any) => {
    setActiveIndex(swiper.activeIndex + 1)
  }, [])

  const getData = useCallback(async () => {
    const { data } = await request.get(`/home/index`)
    setData(data?.data)
    setIsLoad(true)
  }, [])

  useEffect(() => {
    getData()
  }, [])

  return (
    <div className={styles.container}>
      {getHead(navDetail)}
      <div className={classNames([styles.banner, 'banner'])}>
        <Swiper
          className={styles.swiper}
          modules={[Autoplay]}
          spaceBetween={0}
          autoplay
          slidesPerView={1}
        // style={{ height: '31vw' }}
        >
          {
            data?.banner_list &&
            data?.banner_list.map((item: any) => (
              <SwiperSlide key={item.id}>
                <a href={!!item.url ? item.url : 'javascript:;'} target={!!item.url ? '_blank' : '_self'}>
                  <img style={{ width: '100%' }} loading='lazy' src={item.image} alt="" />
                </a>
              </SwiperSlide>
            ))
          }

        </Swiper>
      </div>
      <div className={styles.bannerBtns}>
        <a className={styles.left} href="https://visitor.organic-festa.com/en/register">
          <div>
            <p>Apply to Visit</p>
            <span>Pre-register now and visit the exhibition for free</span>
          </div>
        </a>
        <a className={styles.right} target='_blank' href="https://exhibitor.organic-festa.com/en/apply">
          <div>
            <div>
              <p>Booth Application</p>
              <span>Register online now and become an exhibitor</span>
            </div>
            <img loading='lazy' src="/image/home-apply-icon.png" alt="" />
          </div>
        </a>
      </div>
      <div className={styles.intro}>
        <div>
          <h1>Organic Festa Asia</h1>
          <div>
            <p>The exhibition is dedicated to bringing together global organic agriculture experts, brands, technological innovators and eco-pioneers, displaying the latest organic products, innovative technologies and sustainable solutions, advocating an organic sustainable lifestyle, creating business opportunities for exhibitors, promoting the development of organic industries in Asia and even the world, enhancing market awareness and acceptance, providing in-depth exchange opportunities for producers, distributors and consumers, and helping the future development of the organic market.</p>
            <a href="/en/about/overview">View More</a>
          </div>
        </div>
      </div>
      <div className={styles.introLink}>
        <a href="https://exhibitor.organic-festa.com/en/login" target='_blank'>
          <img loading='lazy' src="/image/organic.png" alt="" />
          <p>Exhibitor Center</p>
          <span>Green future, intelligent organic leadership, technology empowering new industrial ecology</span>
        </a>
        <a href="https://visitor.organic-festa.com/en/login" target='_blank'>
          <img loading='lazy' src="/image/clover.png" alt="" />
          <p>Visitor Center</p>
          <span>Exciting exhibits invite you to appreciate, high-end forum inspires new ideas.</span>
        </a>
        <a href="/en/contacts" target='_blank'>
          <img loading='lazy' src="/image/earth.png" alt="" />
          <p>Contact Us</p>
          <span>Technology leads the green future, come and join us!</span>
        </a>
      </div>
      <div className={styles.survey}>
        <div className={styles.left}>
          <span>—— Overview</span>
          <h2>Towards the 2025 Organic Industry Exhibition<br />Co draw a new green chapter</h2>
          <p>Organic Festa Asia is a professional platform jointly created by IFOAM - Organics Asia and Messe Düsseldorf (Shanghai) Co., Ltd. It will be held at the Shanghai New International Expo Center from September 3-5, 2025, with the theme of "Sustainable Lifestyle in Organics", covering the entire organic industry chain.</p>
          <div>
            <a href="https://online.organic-festa.com/en/online/exhibitor" className={styles.btn1}>Exhibitors & Products</a>
            <a href="" className={styles.btn2}>Business Matching</a>
          </div>
        </div>
        <div className={styles.right}>
          <img loading='lazy' src="/image/home-video-bg.png" alt="" />
        </div>
      </div>
      <ul className={styles.introData}>
        <li>
          <div>
            <p><CountUp
              end={13000}
              duration={1}
              enableScrollSpy
            /><span>+</span></p>
            <span>Professionals</span>
            <div></div>
          </div>
        </li>
        <li>
          <div>
            <p><CountUp
              end={12000}
              duration={1}
              enableScrollSpy
            /><span style={{ fontSize: '36px' }}>㎡</span></p>
            <span>Exhibition Area</span>
            <div></div>
          </div>

        </li>
        <li style={{ flex: '3' }}>
          <div>
            <p><CountUp
              end={300}
              duration={1}
              enableScrollSpy
            /><span>+</span></p>
            <span>Global Exhibitors</span>
            <div></div>
          </div>
        </li>
        <li>
          <div>
            <p><CountUp
              end={30}
              duration={1}
              enableScrollSpy
            /><span>+</span></p>
            <span>Events</span>
            <div></div>
          </div>
        </li>
      </ul>
      <div className={styles.partner}>
        <span>——Partners</span>
        <h2>Partners To Create An Organic Future</h2>
        <Swiper
          className={styles.swiper}
          modules={[Autoplay, Pagination]}
          spaceBetween={0}
          autoplay
          pagination={{ clickable: true }}
          slidesPerView={1}
          style={{ paddingBottom: "30px" }}
        >
          {
            data.partner_list &&
            chunkArray(data.partner_list, 6)
              ?.map((item: any) => (
                <SwiperSlide>
                  <div className={styles.brandList}>
                    {
                      item.map((child: any) => (
                        <div className={styles.item}>
                          <a href={child.link_cn ? child.link_cn : "javascript:;"} target={child.link_cn ? '_blank' : '_self'} key={child.id}>
                            <img loading='lazy' src={child.image} alt="" />
                          </a>
                          <p>{child.title_en}</p>
                        </div>

                      ))
                    }
                  </div>
                </SwiperSlide>
              ))
          }
        </Swiper>
      </div>
      <div className={styles.events}>
        <div>
          <span>——Events & Forum</span>
          <h2>Organic Future, Building Green Dreams Together
            <p><span>View More</span></p>
          </h2>
          <div className={styles.eventList}>
            <div className={styles.left}>
              <div className={styles.top}>
                <img loading='lazy' src="/image/event-bg1.png" alt="" />
                <div className={classNames([styles.title1, styles.arrow])}>
                  <div>
                    <p>Far away delicacies - A healthy and safe food platform that allows children to eat with peace of mind</p>
                    <span>——The Rise of Organic Ecological Agriculture</span>
                  </div>
                </div>
              </div>
              <div className={styles.bottom}>
                <img loading='lazy' src="/image/event-bg2.png" alt="" />
                <div className={classNames([styles.title2, styles.arrow])}>
                  <div>
                    <p>Organic green food supporting technology, equipment and production</p>
                    <span>——The Rise of Organic Ecological Agriculture</span>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.right}>
              <div className={styles.top}>
                <div className={classNames([styles.title1, styles.arrow])}>
                  <div>
                    <p>Interactive Talks on Agricultural Supply and Demand, Past and Present</p>
                    <span>——The Rise of Organic Ecological Agriculture</span>
                  </div>
                </div>
              </div>
              <div className={styles.bottom}>
                <img loading='lazy' src="/image/event-bg3.png" alt="" />
                <div className={classNames([styles.title1, styles.arrow])}>
                  <div>
                    <p>The Prospects and Development of Organic Products</p>
                    <span>——The Rise of Organic Ecological Agriculture</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.comment}>
        <span>——Exhibitor Evaluation</span>
        <div>
          <div className={styles.left}>
            <h2>Organic Industry Exhibition<br />Inviting you to witness the green transformation!</h2>
            <div>
              <Progress style={{ width: '60%' }} stroke='#0a4020' percent={activeIndex / 3 * 100} />
              <p>
                <span>{activeIndex < 10 ? `0${activeIndex}` : activeIndex}</span>
                <span style={{ margin: '0 5px' }}>/</span>
                <span style={{ color: '#aaa' }}>03</span>
              </p>
            </div>

          </div>
          <div className={styles.right}>
            <Swiper
              modules={[Autoplay]}
              spaceBetween={0}
              autoplay
              slidesPerView={1}
              style={{ height: 'auto' }}
              onSlideChange={(swiper: any) => handleSlideChange(swiper)}
            >
              <SwiperSlide>
                <p>Messe Düsseldorf (Shanghai) Co., Ltd. will utilize its rich experience in exhibition organization and market layout in the Asian center, combined with the professional knowledge and industry influence of the International Federation of Organic Agriculture Asia (IFOAM Organics Asia), to jointly provide a high standard display and communication platform for the organic industry. This not only helps to enhance the market awareness and acceptance of organic products, but also provides more business opportunities and market expansion possibilities for participating companies.</p>
                <div className={styles.commentBottom}>
                  <div>
                    <div className={styles.logo}>
                      <img loading='lazy' src="/image/logo1.png" alt="" />
                    </div>
                    <p>Messe Düsseldorf<span>Yan Gu  General Manager</span></p>
                  </div>
                  <img loading='lazy' src="/image/home-comment-icon.png" alt="" />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <p>Messe Düsseldorf (Shanghai) Co., Ltd. will utilize its rich experience in exhibition organization and market layout in the Asian center, combined with the professional knowledge and industry influence of the International Federation of Organic Agriculture Asia (IFOAM Organics Asia), to jointly provide a high standard display and communication platform for the organic industry. This not only helps to enhance the market awareness and acceptance of organic products, but also provides more business opportunities and market expansion possibilities for participating companies.</p>
                <div className={styles.commentBottom}>
                  <div>
                    <div className={styles.logo}>
                      <img loading='lazy' src="/image/logo1.png" alt="" />
                    </div>
                    <p>Messe Düsseldorf<span>Yan Gu  General Manager</span></p>
                  </div>
                  <img loading='lazy' src="/image/home-comment-icon.png" alt="" />
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>

      </div>
      <div className={styles.photos}>
        <img loading='lazy' src="https://img.organic-festa.com/uploads/editor/20250424/93a499967e55b8f819cab82d3d222b9b.jpg" alt="" />
        <img loading='lazy' src="https://img.organic-festa.com/uploads/editor/20250424/09517ae2bfc50de5aebfefbb2f09be65.jpg" alt="" />
        <img loading='lazy' src="https://img.organic-festa.com/uploads/editor/20250424/a2d443b0b8754b03cf43627418123c95.jpg" alt="" />
        <img loading='lazy' src="https://img.organic-festa.com/uploads/editor/20250424/87bdbaf43b5f27d325573c4749b97047.jpg" alt="" />
        <img loading='lazy' src="https://img.organic-festa.com/uploads/editor/20250424/e34ba805b39cac3938456d278e52cbbc.jpg" alt="" />
        <img loading='lazy' src="https://img.organic-festa.com/uploads/editor/20250424/701f29beb8ac0aa6bbc9c1607381d296.jpg" alt="" />
      </div>
      <div className={styles.news}>
        <div>
          <span>——News Information</span>
          <h2>Learn about the new information of the exhibition
            <p onClick={() => router.push('/en/media/show')}><span>View More</span></p>
          </h2>
          <Swiper
            modules={[Autoplay]}
            autoplay
            breakpoints={
              {
                0: {
                  slidesPerView: 1,
                },
                888: {
                  slidesPerView: 3,
                },
              }
            }
            loop
            spaceBetween={30}
            style={{ height: '369px' }}
          >
            {
              data?.news_list &&
              data.news_list.map((item: any) => (
                <SwiperSlide key={item.id}>
                  <div className={styles.item}>
                    <a href={item.url ? item.url : `/media/news_detail/${item.id}`} target='_blank'>
                      <div className={styles.top}>
                        <div>
                          <span>
                            {
                              item.publish_time ?
                                Object.values(useDate(item.publish_time))
                                  .join('.')
                                : ''
                            }
                          </span>
                          <div className={styles.tag}>{item.category.name_en}</div>
                        </div>
                        <p>{item.title_en}</p>
                      </div>
                      <div className={styles.bottom}>
                        <img src={item.image} loading='lazy' alt="" />
                      </div>
                    </a>
                  </div>
                </SwiperSlide>

              ))
            }
          </Swiper>
        </div>
      </div>
      <div className={styles.exhibitor}>
        <div className={styles.title}>
          <span>——Recommended Exhibitors</span>
          <h2>The organic industry is booming<br />Green development leads the trend
            <p><span>View More</span></p>
          </h2>
        </div>
        <Swiper
          className={styles.logoSwiper}
          modules={[Autoplay]}
          spaceBetween={30}
          autoplay
          loop
          breakpoints={
            {
              0: {
                slidesPerView: 3,
              },
              888: {
                slidesPerView: 5,
              },
            }
          }
          style={{ height: 'auto' }}
        >
          {
            data?.recommended_exhibitor_list &&
            data.recommended_exhibitor_list
              .slice(0, Math.ceil(data.recommended_exhibitor_list.length / 2))
              .map((item: any) => (
                <SwiperSlide key={item.id}>
                  <a href={item.url ? item.url : "javascript:;"} target={item.url ? '_blank' : '_self'}>
                    <div className={styles.logoBox}>
                      <img loading='lazy' src={item.image} alt="" />
                    </div>
                  </a>
                </SwiperSlide>
              ))
          }
        </Swiper>
        <Swiper
          className={styles.swiper2}
          modules={[Autoplay]}
          breakpoints={
            {
              0: {
                slidesPerView: 3,
              },
              888: {
                slidesPerView: 5,
              },
            }
          }
          autoplay
          loop
          style={{ height: 'auto' }}
        >
          {
            data?.recommended_exhibitor_list &&
            data.recommended_exhibitor_list
              .slice(Math.ceil(data.recommended_exhibitor_list.length / 2))
              .map((item: any) => (
                <SwiperSlide key={item.id}>
                  <a style={{ marginRight: '30px', display: 'block' }} href={item.url ? item.url : "javascript:;"} target={item.url ? '_blank' : '_self'}>
                    <div className={styles.logoBox}>
                      <img loading='lazy' src={item.image} alt="" />
                    </div>
                  </a>
                </SwiperSlide>
              ))
          }
        </Swiper>
      </div>
      <style global jsx>
        {
          `
          .swiper-pagination-bullet{
            width: 40px;
            height: 6px;
            border-radius: 2px;
            background-color: #e3e3e3;
          }
          .swiper-pagination-bullet{
            background-color: #393637;
          }
          .swiper-pagination-bullet-active{
            background-color:#93d40b !important;
          }
          `
        }
      </style>
    </div>
  );
};

export default Home;
